import React from 'react';
import ContextMenu, { Option } from 'kingpin/atoms/ContextMenu';
import usePopup from 'hooks/usePopup';
import FindAndReplace from './FindAndReplace';
import FindAndReplaceHistory from './FindAndReplaceHistory';
import ArchiveUnusedMetrics from './ArchiveUnusedMetrics';
import MergeDuplicateMetrics from './MergeDuplicateMetrics';

const MetricContextMenu = () => {
  const {
    isOpen: isFindAndReplaceOpen,
    open: openFindAndReplace,
    close: closeFindAndReplace,
  } = usePopup();
  const {
    isOpen: isFindAndReplaceHistoryOpen,
    open: openFindAndReplaceHistory,
    close: closeFindAndReplaceHistory,
  } = usePopup();
  const {
    isOpen: isArchiveUnusedMetricsOpen,
    open: openArchiveUnusedMetrics,
    close: closeArchiveUnusedMetrics,
  } = usePopup();
  const {
    isOpen: isMergeDuplicateMetricsOpen,
    open: openMergeDuplicateMetrics,
    close: closeMergeDuplicateMetrics,
  } = usePopup();
  return (
    <>
      <ContextMenu testId={'metric-context-menu'} buttonType="Secondary">
        <Option label="Find & Replace" onClick={openFindAndReplace} />
        <Option
          onClick={openFindAndReplaceHistory}
          label="Find & Replace History"
        />
        <Option
          onClick={openArchiveUnusedMetrics}
          label="Archive Unused Metrics"
        />
        <Option
          onClick={openMergeDuplicateMetrics}
          label="Merge Duplicate Metrics"
        />
      </ContextMenu>
      <FindAndReplace
        close={closeFindAndReplace}
        isOpen={isFindAndReplaceOpen}
      />
      <FindAndReplaceHistory
        close={closeFindAndReplaceHistory}
        isOpen={isFindAndReplaceHistoryOpen}
      />
      <ArchiveUnusedMetrics
        close={closeArchiveUnusedMetrics}
        isOpen={isArchiveUnusedMetricsOpen}
      />
      <MergeDuplicateMetrics
        close={closeMergeDuplicateMetrics}
        isOpen={isMergeDuplicateMetricsOpen}
      />
    </>
  );
};

export default MetricContextMenu;
